import { FilterType } from 'components/Shared/Table'
import moment from 'moment'

export const columns = [
  {
    id: 'name',
    label: 'groups.table.name',
    path: 'name',
    sortable: true,
    filterType: FilterType.Text
  },
  {
    id: 'createdAt',
    label: 'groups.table.createdAt',
    path: 'createdAt',
    sortable: true,
    filterType: FilterType.None,
    renderFunc: createdAt => moment(createdAt).format('YYYY-MM-DD HH:mm'),
  }
]
